import React, { useEffect, useState } from 'react';
import { Link as Anchor, useLocation } from 'react-router-dom';
import Modal from 'react-modal';
import logo from '../../images/logo.png';
import baseURL from '../url';
import 'swiper/swiper-bundle.css';
import Profile from '../Profile/Profile';
import './Navbar.css';
import Favoritos from '../Favoritos/Favoritos';
import InputSerach from '../InputSerach/InputSearchs';
import Logout from '../Admin/Logout/Logout';

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [usuario, setUsuario] = useState({});
    const [whatsappShareUrl, setWhatsappShareUrl] = useState('');

    // Generar enlace de WhatsApp al montar el componente
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const currentUrl = encodeURIComponent(window.location.href);
            // Opcional: añadir un mensaje antes de la URL
            const message = encodeURIComponent('\n\n¡Mira esto que encontré! 👀');
            const fullText = `${currentUrl}${message}`;
            setWhatsappShareUrl(`https://api.whatsapp.com/send?text=${fullText}`);
        }
    }, []);

    useEffect(() => {
        cargarBanners();
    }, []);

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const bannerImages = data.banner.map(banner => banner.imagen);
                setImages(bannerImages);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar productos:', error);
            });
    };

    useEffect(() => {
        fetch(`${baseURL}/userLogued.php`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                setUsuario(data);
                setLoading(false);
                console.log(data);
            })
            .catch(error => {
                console.error('Error al obtener datos:', error);
                setLoading(false);
            });
    }, []);

    return (
        <header>
            <nav>
                <Anchor to={`/`} className='logo'>
                    <img src={logo} alt="logo" />
                </Anchor>

                <div className='deFLexNavs'>
                    <div className="fondo-input">
                        <div className="search-container">
                            <a 
                                href={whatsappShareUrl} 
                                target="_blank" 
                                rel="noopener noreferrer"
                            >
                                <img 
                                    src="https://cogelobarato.com/imagenes_productos/compartir-btn.png" 
                                    alt="Compartir en WhatsApp" 
                                    className="whatsapp-share-icon"
                                />
                            </a>
                        </div>
                    </div>
                    <Favoritos />
                    <InputSerach />

                    <div 
                        className={`nav_toggle ${isOpen && "open"}`} 
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                <Modal
                    isOpen={isOpen}
                    onRequestClose={() => setIsOpen(false)}
                    className="modalNav"
                    overlayClassName="overlay"
                >
                    <div className="modalNav-content">
                        {loading ? (
                            <div className='loadingBannerFondo'></div>
                        ) : (
                            <>
                                <div className='fondo'>
                                    <img src={images[0]} alt="banner" />
                                </div>
                                <Profile />
                                {usuario.idUsuario ? <Logout /> : null}
                            </>
                        )}
                    </div>
                </Modal>
            </nav>
        </header>
    );
}